import React, {useEffect} from "react";
import {Button, Col, Row} from "react-bootstrap";
import {ActivityAttributesSelect} from "Components/Activities/ActivityAttributesSelect";
import {Notificator} from "Services/Notificator/Notificator";
import {SelectOptionType} from "Model/Select/SelectOption";

interface Props {
    defaultValues?: any,
    onAddAttribute?: (attribute: SelectOptionType|null, value: string) => void,
    onChange?: (attributes: AttributeItem[]) => void,
}

export interface AttributeItem {
    id: string,
    name: string,
    value: string
}

export const ActivityAttributesManager: React.FC<Props> = (props) => {

    const [attributes, setAttributes] = React.useState<AttributeItem[]>([])
    const [attribute, setAttribute] = React.useState<SelectOptionType|null>(null)
    const [value, setValue] = React.useState<string>("")

    const addAttribute = () => {
        if (!attribute || !value) {
            Notificator.error("Debes seleccionar un atributo y añadir un valor.")
            return;
        }

        const newAttribute: AttributeItem = {
            id: attribute.value,
            name: attribute.label,
            value: value
        }
        const attributesList = [...attributes, newAttribute]
        setAttributes(attributesList)
        Notificator.success("Atributo añadido correctamente.")

        if (props.onAddAttribute) {
            props.onAddAttribute(attribute, value)
        }

        if (props.onChange) {
            props.onChange(attributesList)
        }

        setAttribute(null)
        setValue('')
    }

    useEffect(() => {
        setAttributes(props.defaultValues ?? [])
    }, [props.defaultValues]);

    return (
        <>
            <Row className={"mb-3"}>
                <Col sm={12} lg={4}>
                    <label>Atributo</label>
                    <ActivityAttributesSelect
                        value={attribute}
                        onChange={(attr: SelectOptionType|null) => setAttribute(attr)}
                    />
                </Col>
                <Col sm={12} lg={6}>
                    <label>Valor</label>
                    <textarea
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        className="form-control"
                        placeholder="Introduce el valor del atributo"
                    />
                </Col>
                <Col sm={12} lg={2} className={"d-flex align-items-end align-items-center"}>
                    <Button
                        onClick={addAttribute}
                        className={"purple-btn w-100"}
                    >
                        Añadir atributo
                    </Button>
                </Col>
            </Row>
            <br/>

            <table className="table table-bordered redTable">
                <thead>
                    <tr>
                        <th>Atributo</th>
                        <th>Valor</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {attributes.length === 0 && (
                        <tr>
                            <td colSpan={3} className="text-center">No hay atributos</td>
                        </tr>
                    )}
                    {attributes.map((attr, index) => (
                        <tr key={index}>
                            <td>{attr.name}</td>
                            <td>{attr.value}</td>
                            <td>
                                <Button
                                    className={"btn-sm"}
                                    variant="danger"
                                    onClick={() => {
                                        if (!window.confirm("¿Estás seguro de que quieres eliminar este atributo?")) {
                                            return;
                                        }

                                        const newAttributes = attributes.filter((_, i) => i !== index);
                                        setAttributes(newAttributes);
                                        Notificator.success("Atributo eliminado correctamente.");

                                        if (props.onChange) {
                                            props.onChange(newAttributes)
                                        }
                                    }}
                                >
                                    Eliminar
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
}
